import React from "react";

const Blackport = () => {
  return (
    <div>
      <h1>Blackport</h1>
      <p>
        Blackport was founded during the time of the Zelathi Empire. As one sails
        down the Arandor River, Blackport is the last city before the river spreads
        out into a broad delta called the Blackwater Fens, from whence the city gets it's name,
        and then to the ocean. Thus, it has historically been one the major port cities of Crucible.
      </p>


      <p>
        In the last hundred years, it has become a major city of commerce, filled with forges and foundries that belch a 
        never-ending stream of soot into the air. The ruler of the city
      </p>

      <p>
        Today Blackport is ruled by Duke Francis Tachivello. He took the throne about 15 years ago when his father, 
        the previous Duke, died in the attack on Esa. Francis was only 16 at the time, and pushed hard for an isolationist 
        stance. With the fall of the Empire, he wanted to pull back and protect Arandor and Blackport, not send armies off to other lands.
      </p>  

      <p>
        He has a reputation for not tolerating dissent, and had several of the "old guard" of the Duke's Council imprisoned for 
        publicly speaking out against his isolationist stance. Most of the common folk don't particularly like him, but also 
        consider him a pretty clever guy. He's managed to hold onto power even from a young age, during a time of considerable 
        turmoil, even as others have angled to overthrow him.
      </p>  

      <p>
        His power is balanced by the guilds. While wielding very little de jure power, they have traditionally held quite a 
        lot de facto power. Each guild is responsible for the production and quality of goods and services in their sphere. 
        For instance, the Doctors Guild is responsible for doctors. They train and sanction new doctors in the city. Thus, 
        practicing medicine without their approval is a crime.
      </p>  
 

      <h2>Feel</h2>
      <p>
        I want Blackport to have a kind of high-crime underbelly feel, with smokestacks dumping
        ash into the city so there's a smog some days, and a layer of grime on everything. The
        ruler is not well-liked among the citizenry, but his father was a war hero, and there
        doesn't seem to be any good candidates to replace him with right now.
      </p>


      <h2>Development</h2>
      <p>
        If you want to be from Blackport and want to detail a criminal organization, noble family, merchant guild, or whatever, go wild <span role="img" aria-label="simily face">😀</span>
      </p>

    </div>
  );
};

export default Blackport;
